export enum TrackingCalledSectionDashboardEnum {
    HOME_CONTACT,
    HOME_NEWS,
    HOME_SALES_CONCIERGE,
    MENU,
    HOME_PRODUCT_SEARCH,
    HOME_FILTER_BROTHER_PRINTER,
    HOME_FILTER_BROTHER_SCANNER,
    HOME_FILTER_BROTHER_MF,
    HOME_FILTER_BROTHER_LABELER,
    HOME_FILTER_BROTHER_FAX,
    HOME_SHOW_BROTHER_SOLUTIONS,
}
